// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import O1HD from "../../../engines/gameEngine";
import { MessageEventKind } from "../../../modes/define/MessageEventKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HelpWifeLayer3 extends BasePopUpLayer {

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.chatNode.scale = 0;
        this.chatNode.active = true;
        this.showOneChat('相公，咱们赶紧离开这个地方~');
    }

    async showOneChat(chat:string){
        cc.Tween.stopAllByTarget(this.chatNode);
        this.chatNode.scale = 0;
        let lbChat:cc.Label = this.chatNode.getChildByName("label").getComponent(cc.Label);
        lbChat.string = chat;
        cc.tween(this.chatNode)
        .to(0.2,{scale:1},{easing:cc.easing.backOut})
        .delay(5)
        .to(0.2, {scale: 0},{easing:cc.easing.backIn})
        .start();
    }

    onClickClose() {
        O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }
    
    // update (dt) {}
}
